
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/employer/manage-payment-methods",
      function () {
        return require("private-next-pages/employer/manage-payment-methods.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/employer/manage-payment-methods"])
      });
    }
  